import React, { Component } from 'react';
import { GeckoCard } from '../../components';

export class FourOFourPage extends Component {

    render() {
        return (
            <GeckoCard>
            <div className="four-o-four-wrapper">
                <div className="four-o-four-content flex flex-col gap-2 justify-center items-center">
                    <h2 className="text-2xl font-semibold text-foreground">404</h2>
                    <p className="text-sm text-muted-foreground font-medium text-center text-balance">Sorry, we're having trouble trying to find what you're looking for.</p>
                </div>
            </div>
            </GeckoCard>
        );
    }
    
}

export default FourOFourPage;